/*
 * Patches every modal-opener button inside <product-recommendations> so its
 * `data-product-url` carries `?view=quickview`. The quickview template is a
 * stripped-down product template that always contains <product-info>, which
 * Dawn's QuickAddModal needs to extract from the fetched HTML. Without this
 * patch, opening Quick Add on a product whose default template doesn't
 * include the main-product section (e.g. PageFly-templated products)
 * crashes at `QuickAddModal.preprocessHTML` with
 * "Cannot read properties of null (reading 'classList')".
 *
 * We rewrite the attribute rather than modifying card-product.liquid so the
 * change is scoped to this section only.
 */
(function () {
  function patchUrl(button) {
    if (!button || button.dataset.quickviewPatched === 'true') return;
    const raw = button.getAttribute('data-product-url');
    if (!raw) return;
    try {
      const url = new URL(raw, location.origin);
      if (url.searchParams.get('view') !== 'quickview') {
        url.searchParams.set('view', 'quickview');
        button.setAttribute('data-product-url', url.pathname + url.search);
      }
    } catch (e) {
      // Fallback for malformed URLs — append the param manually.
      const sep = raw.includes('?') ? '&' : '?';
      button.setAttribute('data-product-url', raw + sep + 'view=quickview');
    }
    button.dataset.quickviewPatched = 'true';
  }

  function patchScope(scope) {
    scope.querySelectorAll('modal-opener button[data-product-url]').forEach(patchUrl);
  }

  function init() {
    document.querySelectorAll('product-recommendations, rebuy-products').forEach((host) => {
      // Patch anything already in the DOM (in case the section was server-rendered).
      patchScope(host);
      // The product-recommendations element replaces its innerHTML when the
      // IntersectionObserver triggers; rebuy-products also injects cards
      // asynchronously. A MutationObserver covers both.
      const mo = new MutationObserver(() => patchScope(host));
      mo.observe(host, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
